import { render, staticRenderFns } from "./ChukuPlan.vue?vue&type=template&id=5f0a2a96&scoped=true&"
import script from "./ChukuPlan.vue?vue&type=script&lang=js&"
export * from "./ChukuPlan.vue?vue&type=script&lang=js&"
import style0 from "./ChukuPlan.vue?vue&type=style&index=0&id=5f0a2a96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a2a96",
  null
  
)

export default component.exports